import Modal from 'antd/es/modal';
import { useEffect } from 'react';
import { useBlocker } from 'react-router';

interface Props {
  enabled: boolean;
  onLeave: () => void;
}

export const ReconciliationNavigationGuard = ({ enabled, onLeave }: Props) => {
  const blocker = useBlocker(enabled);
  useEffect(() => {
    if (!enabled) return;
    const warn = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [enabled]);

  return (
    <Modal
      open={blocker.state === 'blocked'}
      title="¿Salir de la conciliación?"
      okText="Salir y perder seguimiento"
      cancelText="Permanecer aquí"
      onCancel={() => blocker.state === 'blocked' && blocker.reset()}
      onOk={() => {
        if (blocker.state !== 'blocked') return;
        onLeave();
        blocker.proceed();
      }}
    >
      <p>
        Perderás el seguimiento de los empleados pendientes y de los resultados
        sin confirmar. La solicitud actual podría terminar en el servidor.
      </p>
      <p>Al regresar no se reanudará el proceso automáticamente.</p>
    </Modal>
  );
};
